<div style="padding: 1rem;">
    <h2 class="dialog-title">{{ data.message }}</h2>

    <div class="spacer"></div>

    <div class="actions">
    <button matButton="elevated" (click)="onCancelClick()">{{ data.cancelLabel }}</button>
    <button matButton="elevated" (click)="onYesClick()">{{ data.yesLabel }}</button>
    </div>
</div>
